import React, {useContext, useState} from 'react';
import { UserRecoverContext } from "./ShareStates";
import {
    postUserRecoverPasswordReset,
    getMutationResult
} from "../../commonFunctions/GraphqlFunctions";

const PasswordResetRequestForm = () => {
    const {updateDisplayForm} = useContext(UserRecoverContext);
    const [errorValue, setErrorValue] = useState("");
    const [displayError, setDisplayError] = useState("none");
    const [emailValue, setEmailValue] = useState("");

    const inputChange = (event) => {
        event.preventDefault();
        if (event.target.id === "email_address") {
            setEmailValue(event.target.value)
            setErrorValue("")
        }
    }

    const submitAction = async (event) => {
        event.preventDefault();
        if (emailValue !== "") {
            let postUserRecoverPasswordResetResult = await getMutationResult(postUserRecoverPasswordReset(), {"emailAddress": emailValue})
            if (postUserRecoverPasswordResetResult !== undefined) {
                if (postUserRecoverPasswordResetResult.data['supportSiteUserRecoverPasswordReset']['message'] !== undefined) {
                    let messageOutput = postUserRecoverPasswordResetResult.data['supportSiteUserRecoverPasswordReset']['message']
                    if (messageOutput === "invalid email address format") {
                        setErrorValue("Invalid Email Address Format")
                    }
                    if (messageOutput === "no match email address found") {
                        setErrorValue("Invalid Email Address")
                    }
                }
                else {
                    updateDisplayForm("passwordSentRequest")
                }
            }
            else {
                console.log(postUserRecoverPasswordResetResult)
                setDisplayError("block");
            }
        }
        else {
            setErrorValue("Email Address is Required")
        }
    }

    return (
        <React.Fragment>
            <form name={"userRecover"}>
                <input type={"hidden"} name={"return_to"}></input>
                <div id={"resetForm"}>
                    <h1>
                        To reset your password, please enter your email address.  We’ll send instructions and a link to complete the process.
                    </h1>
                    <div className={"errorNotice"} style={{display: displayError}}>
                        There is error contacting the backend server, please contact administrator.
                    </div>
                    <div>
                        <input type={"text"} name={"email_address"} id={"email_address"} className={"required"}
                               placeholder={"Email address"} value={emailValue} onChange={inputChange}></input>
                        <span id={"error_email_address"} className={"error"}>{errorValue}</span>
                    </div>
                    <button type={"submit"} id={"submit"} className={"formSubmit btn"} title={"Submit"} onClick={submitAction}>
                        <span>Request Password Reset</span>
                    </button>
                </div>
            </form>
        </React.Fragment>
    )
}

export default PasswordResetRequestForm;